export default "__VITE_ASSET__DDgQSTYp__"